import { Injectable } from '@angular/core';
import { Client } from '@stomp/stompjs';
import { ListenerMessage } from '../shared/tools/message';
import { v4 as uuidv4 } from 'uuid';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RabbitMQService {
  private client!: Client;
  private replyQueueName: string | null = null;
  private destinationQueue: string = environment.equipmentAlertWs;
  private pendingActions: Array<() => void> = [];
  private initialized = false;

  constructor(
    public userService: UserService,
  ) {
    console.log("Iniciando o websocket via rabbitmq broker");
  }

  public subscribeToQueue(callback: (msg: ListenerMessage) => void) {
    this.connect();
    this.runOrQueue(() => {
      this.client.subscribe(
        `/queue/${this.replyQueueName}`,
        message => {
          const rawBody = (message as any).isBinaryBody && (message as any).binaryBody
            ? new TextDecoder().decode((message as any).binaryBody)
            : message.body;
          const cleanedBody = rawBody.replace(/\r?\n/g, '');
          const m = JSON.parse(cleanedBody);
          callback(m);
          message.ack();
        },
        {
          "ack": "client-individual",
          "durable": "false",
          "auto-delete": "true",
          "exclusive": "false"
        });
    });
  }

  public sendMessage(body: any) {
    this.connect();
    this.runOrQueue(() => {
      console.log("Sending message: ", body);
      this.client.publish({
        destination: `${this.destinationQueue}`,
        body: JSON.stringify(body),
        // headers: {
        //   'reply-to': `${this.replyQueueName}`, // RabbitMQ will map this to the real amq.gen-xxx queue
        // },
      });

      console.log('Sent message with reply-to header');
    });
  }

  public connect() {
    if (this.initialized) {
      return;
    }

    this.replyQueueName = 'mobile-app-reply-to-' + uuidv4();

    this.client = new Client({
      brokerURL: 'wss://services.appvelsis.com/ws',
      connectHeaders: {
        login: 'websocket',
        passcode: 'Websocket@2025',
        host: '/'
      },
      debug: (str) => {
        console.log('STOMP: ', str);
      },
      reconnectDelay: 5000
    });
    this.client.onConnect = () => {
      console.log(`STOMP Connected to RabbitMQ WebSocket Broker. Reply Queue: ${this.replyQueueName}`);
      this.sendMessage(
        { replyTo: this.replyQueueName,
          contrato: this.userService.getCurrentContract()?.id,
          email: this.userService.user?.email
        });
      this.flushPendingActions();
    };

    this.client.activate();
    this.initialized = true;
  }

  private runOrQueue(action: () => void) {
    if (!this.client) {
      this.connect();
    }

    if (this.client.connected) {
      action();
      return;
    }

    this.pendingActions.push(action);
  }

  private flushPendingActions() {
    const queued = [...this.pendingActions];
    this.pendingActions = [];
    queued.forEach(action => action());
  }
}
